import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanLoad,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Route,
  UrlTree
} from '@angular/router';
// import { User } from '@firebase/auth-types';
// import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Auth, authState } from '@angular/fire/auth';

import { take } from 'rxjs/operators';

import { GuardService } from './guard.service';
import { AuthService } from 'app/core/auth.service';

@Injectable()
export class ServerGuardService implements CanActivate, CanLoad {
  constructor(
    private router: Router
    , private _afAuth: Auth
    , private _gs: GuardService
    , private _as: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise<boolean | UrlTree>((resolve) => {
      authState(this._afAuth).pipe(take(1)).subscribe((fbuser) => {
        if (fbuser) {
          this._as.customClaim(fbuser)
          .then(claim => {
            // console.log('server guard resolved: ', claim.server);
            if (claim.server) resolve(true);
            else {
              // authenticated but not server
              resolve(this._gs.notYetAuth(this.router, route, '/home'));
            }
          }).catch(_ => resolve(this._gs.notYetAuth(this.router, route, '/home')));
        } else {
          // not yet authenticated
          resolve(this._gs.notYetAuth(this.router, route));
        }
      });
    });
  }

  canLoad(_route: Route): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      authState(this._afAuth).pipe(take(1)).subscribe((fbuser) => {
        if (fbuser) {
          this._as.customClaim(fbuser)
          .then(claim => resolve(!!claim.server))
          .catch(_ => resolve(false));
        } else {
          // not yet authenticated
          resolve(false);
        }
      });
    });
  }
}
